// eslint-disable-next-line import/no-unresolved
import { captureException as sentryCaptureException } from '@sentry/nextjs';

function captureException(error: any): void {
  sentryCaptureException(error);
  if (process.env.NODE_ENV !== 'production') {
    console.error(error);
  }
}

export default captureException;
